// extracted by css-extract-rspack-plugin
export default {"root":"dV2hR","open":"SKp9S"};